import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AddOrgUI } from '@core/typings/ui/add-org.typing';
import { ContactFormGroup } from '@features/add-organization/add-org-modal/add-org-modal.component';
import { AddOrganizationService } from '@features/add-organization/add-organization.service';
import { TypeSafeFormGroup } from '@yourcause/common/core-forms';
import { HeapService, TrackingEventNames, TrackingPropertyNames } from '@yourcause/common/heap';
import { Subscription } from 'rxjs';

@Component({
    selector: 'gc-add-org-confirmation',
    templateUrl: './add-org-confirmation.component.html',
    styleUrls: ['./add-org-confirmation.component.scss'],
    standalone: false
})
export class AddOrgConfirmationComponent implements OnInit, OnDestroy {
  @Input() nonprofitContactGroup: TypeSafeFormGroup<ContactFormGroup>;

  showContactForm = this.addOrgService.showContact;
  selectedOrg = this.addOrgService.searchResult;
  confirmationText = this.addOrgService.confirmationText;
  helpCenterConfirmationLink = this.addOrgService.helpCenterConfirmationLink;
  sub = new Subscription();

  constructor (
    private addOrgService: AddOrganizationService,
    private heapService: HeapService
  ) { }

  ngOnInit () {
    this.addOrgService.setValidation(
      !this.showContactForm || this.nonprofitContactGroup.valid
    );
    this.sub.add(this.nonprofitContactGroup.statusChanges.subscribe(() => {
      this.addOrgService.setValidation(this.nonprofitContactGroup.valid);
    }));
  }

  updateAddOrg <K extends keyof AddOrgUI.AddOrgPayload> (
    attr: K,
    data: AddOrgUI.AddOrgPayload[K]
  ) {
    this.addOrgService.setAddOrgAttr(attr, data);
  }

  updateVettingContact <K extends keyof AddOrgUI.VettingContactInfo> (
    attr: K,
    data: AddOrgUI.VettingContactInfo[K]
  ) {
    this.addOrgService.setVettingContactInfo(attr, data);
  }

  openHelpCenter () {
    this.heapService.track(
      TrackingEventNames.OpenHelp,
      {
        [TrackingPropertyNames.Link]: this.helpCenterConfirmationLink
      }
    );
    
    window.open(this.helpCenterConfirmationLink, '_blank');
  }

  ngOnDestroy () {
    this.sub.unsubscribe();
  }

}
